export default "__VITE_ASSET__CNgpZGxZ__"